var map = {
	"./app": [
		3962,
		9
	],
	"./app.js": [
		3962,
		9
	],
	"./blocks/accordion": [
		1287,
		9,
		1287
	],
	"./blocks/accordion.js": [
		1287,
		9,
		1287
	],
	"./blocks/funds": [
		5359,
		7,
		5359
	],
	"./blocks/funds.js": [
		5359,
		7,
		5359
	],
	"./blocks/news": [
		8172,
		7,
		8172
	],
	"./blocks/news.js": [
		8172,
		7,
		8172
	],
	"./blocks/video": [
		2956,
		9,
		2956
	],
	"./blocks/video.js": [
		2956,
		9,
		2956
	],
	"./classes/breakpoint": [
		7886,
		9,
		7886
	],
	"./classes/breakpoint.js": [
		7886,
		9,
		7886
	],
	"./classes/scroll-controller": [
		4502,
		9,
		4502
	],
	"./classes/scroll-controller.js": [
		4502,
		9,
		4502
	],
	"./classes/scroll-locker": [
		9137,
		9,
		9137
	],
	"./classes/scroll-locker.js": [
		9137,
		9,
		9137
	],
	"./classes/validation": [
		2384,
		9,
		2384
	],
	"./classes/validation.js": [
		2384,
		9,
		2384
	],
	"./classes/video-embed": [
		9574,
		9,
		9574
	],
	"./classes/video-embed.js": [
		9574,
		9,
		9574
	],
	"./cms": [
		993,
		9,
		993
	],
	"./cms.js": [
		993,
		9,
		993
	],
	"./cms/colourpalette": [
		3705,
		7,
		3705
	],
	"./cms/colourpalette.js": [
		3705,
		7,
		3705
	],
	"./cms/darkmode": [
		6575,
		9,
		6575
	],
	"./cms/darkmode.js": [
		6575,
		9,
		6575
	],
	"./cms/field-names": [
		9107,
		9,
		9107
	],
	"./cms/field-names.js": [
		9107,
		9,
		9107
	],
	"./cms/modal": [
		9186,
		9,
		9186
	],
	"./cms/modal.js": [
		9186,
		9,
		9186
	],
	"./cms/page-observer": [
		9841,
		9,
		9841
	],
	"./cms/page-observer.js": [
		9841,
		9,
		9841
	],
	"./cms/title": [
		3134,
		7,
		3134
	],
	"./cms/title.js": [
		3134,
		7,
		3134
	],
	"./cms/wysiwyg-modal": [
		1834,
		7,
		1834
	],
	"./cms/wysiwyg-modal.js": [
		1834,
		7,
		1834
	],
	"./components/breakpoint": [
		2838,
		9,
		2838
	],
	"./components/breakpoint.js": [
		2838,
		9,
		2838
	],
	"./components/equalizer": [
		364,
		9,
		364
	],
	"./components/equalizer.js": [
		364,
		9,
		364
	],
	"./components/globals": [
		2692,
		9,
		2692
	],
	"./components/globals.js": [
		2692,
		9,
		2692
	],
	"./components/in-view": [
		6102,
		9,
		6102
	],
	"./components/in-view.js": [
		6102,
		9,
		6102
	],
	"./components/lazy-load": [
		6494,
		9,
		6494
	],
	"./components/lazy-load.js": [
		6494,
		9,
		6494
	],
	"./components/parallax": [
		3912,
		9,
		3912
	],
	"./components/parallax.js": [
		3912,
		9,
		3912
	],
	"./components/scroll": [
		3623,
		9,
		3623
	],
	"./components/scroll-to": [
		4599,
		7,
		4599
	],
	"./components/scroll-to.js": [
		4599,
		7,
		4599
	],
	"./components/scroll.js": [
		3623,
		9,
		3623
	],
	"./components/selectors": [
		4340,
		9,
		4340
	],
	"./components/selectors.js": [
		4340,
		9,
		4340
	],
	"./critical": [
		2697,
		9,
		2697
	],
	"./critical.js": [
		2697,
		9,
		2697
	],
	"./editor": [
		6861,
		9,
		6861
	],
	"./editor.js": [
		6861,
		9,
		6861
	],
	"./elements/contact-form": [
		3677,
		9,
		3677
	],
	"./elements/contact-form.js": [
		3677,
		9,
		3677
	],
	"./elements/contact-modal": [
		2087,
		7,
		2087
	],
	"./elements/contact-modal.js": [
		2087,
		7,
		2087
	],
	"./elements/fund-details": [
		590,
		7,
		590
	],
	"./elements/fund-details.js": [
		590,
		7,
		590
	],
	"./elements/funds-navigation": [
		815,
		7,
		815
	],
	"./elements/funds-navigation.js": [
		815,
		7,
		815
	],
	"./elements/header": [
		3523,
		7,
		3523
	],
	"./elements/header.js": [
		3523,
		7,
		3523
	],
	"./elements/mega-menu": [
		4112,
		7,
		4112
	],
	"./elements/mega-menu.js": [
		4112,
		7,
		4112
	],
	"./elements/mobile-menu": [
		4878,
		7,
		4878
	],
	"./elements/mobile-menu.js": [
		4878,
		7,
		4878
	],
	"./elements/pdst": [
		7580,
		7,
		7580
	],
	"./elements/pdst.js": [
		7580,
		7,
		7580
	],
	"./elements/performance-tables": [
		164,
		7,
		164
	],
	"./elements/performance-tables.js": [
		164,
		7,
		164
	],
	"./elements/resources": [
		7542,
		7,
		7542
	],
	"./elements/resources.js": [
		7542,
		7,
		7542
	],
	"./elements/search": [
		212,
		7,
		212
	],
	"./elements/search.js": [
		212,
		7,
		212
	],
	"./elements/subscription-form": [
		7322,
		7,
		7322
	],
	"./elements/subscription-form.js": [
		7322,
		7,
		7322
	],
	"./elements/unit-price": [
		4800,
		7,
		4800
	],
	"./elements/unit-price.js": [
		4800,
		7,
		4800
	],
	"./graphs/investment-mix": [
		2066,
		9,
		8597,
		2066
	],
	"./graphs/investment-mix.js": [
		2066,
		9,
		8597,
		2066
	],
	"./graphs/performance": [
		4042,
		9,
		8597,
		4042
	],
	"./graphs/performance.js": [
		4042,
		9,
		8597,
		4042
	],
	"./pages/blog": [
		5441,
		9,
		5441
	],
	"./pages/blog.js": [
		5441,
		9,
		5441
	],
	"./pages/fund-holder": [
		4136,
		7,
		4136
	],
	"./pages/fund-holder.js": [
		4136,
		7,
		4136
	],
	"./pages/search-results": [
		9231,
		9,
		9231
	],
	"./pages/search-results.js": [
		9231,
		9,
		9231
	],
	"./pages/team": [
		830,
		7,
		830
	],
	"./pages/team.js": [
		830,
		7,
		830
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9877;
module.exports = webpackAsyncContext;